import {
    Stack, Modal, Icon, Box, CircularProgress
} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';

const ItemsListV2 = ({ items, itemsLoading, itemDetailed, closeDetailed }) => {
    return (
        <Stack spacing={2} sx={{m: 1}}>
            {
                itemDetailed ?
                    <Modal
                        open={itemDetailed}
                        sx={{overflow: 'auto', height: '100vh', zIndex: 1305}}
                    >
                        <Box
                            sx={{position: 'relative', minHeight: '100vh'}}
                        >
                            <Icon
                                onClick={closeDetailed}
                                sx={{
                                    '&:hover': { cursor: 'pointer', backgroundColor: "#000", color: "#fff"},
                                    p: "3px",
                                    backgroundColor: "#eee",
                                    borderRadius: '8px',
                                    position: 'absolute', top: '10px', right: '10px'}}
                            >
                                <ClearIcon/>
                            </Icon>
                            { itemDetailed }
                        </Box>
                    </Modal>:
                       itemsLoading ?
                        <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <CircularProgress size={'30px'} aria-label="Loading…" />
                        </Box>  : items
            }
        </Stack>
    );
}

export default ItemsListV2;
